import { getOriginFromUrl } from "@/lib/tools/toolUrls";

const iframesByTool = new Map();
const pendingCommandsByTool = new Map();

const normalizeTool = (tool) => String(tool || "").trim().toLowerCase();

const buildMessage = (pendingCommand) => ({
  type: "comrcehub.tool.command",
  version: 1,
  commandId: pendingCommand.commandId,
  command: {
    ...pendingCommand.command,
    relatedEntities: pendingCommand.relatedEntities,
    metadata: pendingCommand.metadata,
  },
});

const sendPendingCommands = (tool) => {
  const normalizedTool = normalizeTool(tool);
  const registration = iframesByTool.get(normalizedTool);
  if (!registration?.iframe?.contentWindow || !registration.loaded) return;

  const pending = pendingCommandsByTool.get(normalizedTool) ?? [];
  if (pending.length === 0) return;

  const origin = registration.origin || getOriginFromUrl(registration.url);
  if (!origin) return;

  const remaining = [];

  pending.forEach((pendingCommand) => {
    if (registration.sentCommandIds.has(pendingCommand.commandId)) return;

    registration.iframe.contentWindow.postMessage(
      buildMessage(pendingCommand),
      origin,
    );
    registration.sentCommandIds.add(pendingCommand.commandId);
  });

  pendingCommandsByTool.set(normalizedTool, remaining);
};

export const registerToolIframe = ({ tool, iframe, url, tabId }) => {
  const normalizedTool = normalizeTool(tool);
  if (!normalizedTool || !iframe) return () => {};

  const registration = {
    iframe,
    url,
    tabId,
    origin: getOriginFromUrl(url),
    loaded: false,
    sentCommandIds: new Set(),
  };

  iframesByTool.set(normalizedTool, registration);

  return () => {
    if (iframesByTool.get(normalizedTool) === registration) {
      iframesByTool.delete(normalizedTool);
    }
  };
};

export const markToolIframeLoaded = (tool) => {
  const normalizedTool = normalizeTool(tool);
  const registration = iframesByTool.get(normalizedTool);
  if (!registration) return;

  registration.loaded = true;
  sendPendingCommands(normalizedTool);
};

export const queueToolCommand = ({
  tool,
  command,
  relatedEntities,
  metadata,
}) => {
  const normalizedTool = normalizeTool(tool);
  if (!normalizedTool || !command) return;

  const pendingCommand = {
    commandId:
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random()}`,
    command,
    relatedEntities,
    metadata,
  };

  const pending = pendingCommandsByTool.get(normalizedTool) ?? [];
  pendingCommandsByTool.set(normalizedTool, [...pending, pendingCommand]);
  sendPendingCommands(normalizedTool);
};
